import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { revenueFromSubscription: { getRevenueFromSubscription, } } = apiUrls;

export const GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS = 'GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS';
export const GET_REVENUE_FROM_SUBSCRIPTION_LOADING = 'GET_REVENUE_FROM_SUBSCRIPTION_LOADING';


export const getRevenueFromSubscriptionData = ({ from: fromyear, to: toyear,
    fromMonth: frommonth, toMonth: tomonth }) => async (dispatch) => {
        try {
            const { url } = getRevenueFromSubscription
            const requestData = {
                ...getRevenueFromSubscription,
                url: url.replace('{{fromyear}}', fromyear).replace('{{toyear}}', toyear)
                // .replace('{{frommonth}}', frommonth).replace('{{tomonth}}', tomonth)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: GET_REVENUE_FROM_SUBSCRIPTION_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: GET_REVENUE_FROM_SUBSCRIPTION_LOADING,
        isLoading
    })
}
